import { defineMessages } from 'react-intl';

export const messages: {
	betaTag: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	underDevelopmentTag: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	betaTag: {
		id: 'dtac.labs.navigationBar.betaTag',
		defaultMessage: 'Beta',
		description: 'Beta tag label for Labs app',
	},
	underDevelopmentTag: {
		id: 'dtac.assistant.navigationBar.underDevelopmentTag',
		defaultMessage: 'Under development',
		description: 'Under development tag label for Assistant app',
	},
});
